import {
	authLogin,
	ForgotPassword,
	GetChannels,
	RefreshToken,
	UpdatePassword,
	authCode,
	tempPhone,
	UpdateOnboarding,
	SetAdminPassword,
	UpdateChannel,
	GetChannelsFromStoredSession,
	GetAccountFromStoredSession
} from '../../connection/auth';
import { GreenroomLogin } from '../../connection/create-event';
import { Action, AsyncAction } from '../../types/actions';
import { Channel, Profile } from '../../types/working-model';

export const SIGN_IN = 'SIGN_IN';
export function signIn(
	email: string,
	password: string,
	two_factor_stored: string | null
): AsyncAction {
	return {
		type: SIGN_IN,
		promise: authLogin(email, password, two_factor_stored),
	};
}

export const SET_TEMP_NUMBER = 'SET_TEMP_NUMBER';
export function setTempNumber(
	number: string,
	temp_profile: string
): AsyncAction {
	return {
		type: SET_TEMP_NUMBER,
		promise: tempPhone(number, temp_profile)
	};
}

export const CONFIRM_CODE = 'CONFIRM_CODE';
export function confirmCode(
	temp_profile: string,
	code: string,
	should_confirm: boolean,
	request_storage: boolean
): AsyncAction {
	return {
		type: CONFIRM_CODE,
		promise: authCode(temp_profile, code, should_confirm, request_storage),
	};
}

export const FORGOT_PASSWORD = 'FORGOT_PASSWORD';
export function forgotPassword(email: string, hostname: string): AsyncAction {
	return {
		type: FORGOT_PASSWORD,
		promise: ForgotPassword(email, hostname),
	};
}

export const UPDATE_PASSWORD = 'UPDATE_PASSWORD';
export function updatePassword(password: string, code: string, cb: () => void): AsyncAction {
	return {
		type: UPDATE_PASSWORD,
		promise: UpdatePassword(password, code, cb),
	};
}

export const SET_USER = 'SET_USER';
export function setUser(token: string): Action {
	return {
		type: SET_USER,
		payload: token,
	};
}

export const REFRESH_TOKEN = 'REFRESH_TOKEN';
export function refreshToken(token: string): AsyncAction {
	return {
		type: REFRESH_TOKEN,
		promise: RefreshToken(token),
	};
}

export const SIGN_OUT = 'SIGN_OUT';
export function signOut(): Action {
	return {
		type: SIGN_OUT,
		payload: true,
	};
}

export const GET_ADMIN_CHANNELS = 'GET_ADMIN_CHANNELS';
export function getAdminChannels(token: string): AsyncAction {
	return {
		type: GET_ADMIN_CHANNELS,
		promise: GetChannels(token),
	};
}

export const SET_CHANGING_CHANNELS = 'SET_CHANGING_CHANNELS';
export function setChangingChannels(isChangingChannels: boolean): Action {
	return {
		type: SET_CHANGING_CHANNELS,
		payload: isChangingChannels,
	};
}

export const UPDATE_CHANNEL = "UPDATE_CHANNEL";
export function updateChannel(token: string, channel: Channel): AsyncAction {
	return {
		type: UPDATE_CHANNEL,
		promise: UpdateChannel(token, channel)
	};
}

export const SET_ADMIN_PASSWORD = "SET_ADMIN_PASSWORD";
export function setAdminPassword(password: string, code: string, cb: () => void): AsyncAction {
	return {
		type: SET_ADMIN_PASSWORD,
		promise: SetAdminPassword(password, code, cb)
	};
}

export const ADD_CHECKLIST_ITEM = 'ADD_CHECKLIST_ITEM';
export function addChecklistItem(token: string, id: number, onboarding: string[], newItem: string): AsyncAction {
	return {
		type: ADD_CHECKLIST_ITEM,
		promise: UpdateOnboarding(token, id, onboarding, newItem)
	};
}

export const CLEAR_CHECKLIST = 'CLEAR_CHECKLIST';
export function clearChecklist(): Action {
	return {
		type: CLEAR_CHECKLIST,
		payload: true
	};
}

export const COMPLETE_WELCOME_ONBOARDING = 'COMPLETE_WELCOME_ONBOARDING';
export function completeWelcomeOnboarding(token: string, id: number, onboarding: string[]): AsyncAction {
	return {
		type: COMPLETE_WELCOME_ONBOARDING,
		promise: UpdateOnboarding(token, id, onboarding, "welcome")
	};
}

export const UPDATE_ADMIN_PROFILE = 'UPDATE_ADMIN_PROFILE';
export function updateAdminProfile(profile: Profile): Action {
	return {
		type: UPDATE_ADMIN_PROFILE,
		payload: profile
	};
}
//TODO: create password from email invite

export const GET_CHANNELS_INFO_FOR_ADMIN = 'GET_CHANNELS_INFO_FOR_ADMIN';
export function getChannelsInfo(token: string): AsyncAction {
	return {
		type: GET_CHANNELS_INFO_FOR_ADMIN,
		promise: GetChannelsFromStoredSession(token)
	};
}


export const GET_ACCOUNT_INFO_BY_STORED_TOKEN = 'GET_ACCOUNT_INFO_BY_STORED_TOKEN ';
export function getAccountInfo(token: string): AsyncAction {
	return {
		type: GET_ACCOUNT_INFO_BY_STORED_TOKEN,
		promise: GetAccountFromStoredSession(token)
	};
}

export const SET_CHANNEL_SSO_INFO = 'SET_CHANNEL_SSO_INFO';
export function setChannelSSO(ssoConfiguration: Channel): Action {
	return {
		type: SET_CHANNEL_SSO_INFO,
		payload: ssoConfiguration
	};
}

export const GREENROOM_LOGIN = "GREENROOM_LOGIN";
export function greenroomLogin(token: string): AsyncAction {
	return {
		type: GREENROOM_LOGIN,
		promise: GreenroomLogin(token)
	};
}